import { Component } from '@angular/core';
import {IonicPage, NavController, NavParams, ToastController, ViewController} from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { ServiceProvider } from '../../providers/service/service';
import {Calendar} from "@ionic-native/calendar";

/**
 * Generated class for the AddCallReminderPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

//@IonicPage()
@Component({
  selector: 'page-add-call-reminder',
  templateUrl: 'add-call-reminder.html',
})
export class AddCallReminderPage {

  Comment:any;
  date:any;

  studentData:any;

  studentName:any;

  FUserId:any;
  userName:any;
  FCallReminderId:any;
  FCallStatusId:any;

  dataFromEnquiry:any;
  time:any;

  send_data:any;

  changeStatus:any;
  Status:any;

  FWebEnquiryId:any;
  FDataId:any;
  FStatusId:any;
  Name:any;
  SchoolId:any;
  Phone1:any;
  Phone2:any;
  Standard:any;

  PreData:any;

  rdate:any;

  constructor(public navCtrl: NavController, public navParams: NavParams,public calendar:Calendar,
    public storage: Storage,public service:ServiceProvider,public toastCtrl:ToastController,public viewCtrl:ViewController)
  {
    //calls module
    this.studentData=navParams.get('item');
    if(this.studentData)
    {
      this.changeStatus=navParams.get('changeStatus');
      this.FCallReminderId=this.studentData['Id'];
      this.studentName=this.studentData['Name'];
      this.Comment=this.studentData['Comment_'];
      this.FCallStatusId=navParams.get('FCallStatusId');

    }


    //data module
    this.dataFromEnquiry=navParams.get('enquiry');
    console.log("dataFromEnquiry->",this.dataFromEnquiry);
    if(this.dataFromEnquiry)
    {
      this.Status=navParams.get('TapStatus');
      console.log("this.Status->",this.Status);
      if(this.Status=='Apmt'){
        this.FCallReminderId=this.dataFromEnquiry['FWebEnquiryId'];
        this.studentName=this.dataFromEnquiry['Name1'];
        this.Comment=this.dataFromEnquiry['Comment'];
        this.FCallStatusId=navParams.get('FCallStatusId');

        this.FWebEnquiryId=this.dataFromEnquiry['FWebEnquiryId'];
        this.FDataId=this.dataFromEnquiry['DataId'];
        this.FStatusId=this.dataFromEnquiry['Status'];
        this.Name=this.dataFromEnquiry['Name1'];
        this.SchoolId=this.dataFromEnquiry['FSchoolId'];
        this.Phone1=this.dataFromEnquiry['Phone1'];
        this.Phone2=this.dataFromEnquiry['Phone2'];
        this.Standard=this.dataFromEnquiry['FStandardId'];

      }else{
        this.FCallReminderId=this.dataFromEnquiry['Id'];
        this.studentName=this.dataFromEnquiry['StudentName'];
        this.Comment=this.dataFromEnquiry['Comment_'];
        this.FCallStatusId=navParams.get('FCallStatusId');

        this.FWebEnquiryId=this.dataFromEnquiry['Id'];
        this.FDataId=this.dataFromEnquiry['DataId'];
        this.FStatusId=this.dataFromEnquiry['Status'];
        this.Name=this.dataFromEnquiry['StudentName'];
        this.SchoolId=this.dataFromEnquiry['SchoolId'];
        this.Phone1=this.dataFromEnquiry['PhoneNumber1'];
        this.Phone2=this.dataFromEnquiry['PhoneNumber2'];
        this.Standard=this.dataFromEnquiry['StandardId'];
      }

    }
    console.log(this.dataFromEnquiry);



    Promise.all([this.storage.get('LoginData'),this.storage.get('UserData')]).then(values => {

      this.FUserId = values[0]['FUserId'];
      this.userName=values[1]['Name'];

    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AddCallReminderPage');
  }

  open_Calendar(){
    this.calendar.createCalendar('MyCalendar').then(
      (msg) => { console.log(msg); },
      (err) => { console.log(err); }
    );
  }

  setdate(){
    console.log("date",this.date);
  }


  add_student_reminder()
  {

    if(this.studentData)
    {
      this.send_data={
        FWebEnquiryId:this.studentData['FWebEnquiryId'],
        FDataId:this.studentData['FDataId'],
        FStatusId:this.studentData['FStatusId'],
        Name:this.studentData['Name'],
        SchoolId:this.studentData['SchoolId'],
        Phone1:this.studentData['Phone1'],
        Phone2:this.studentData['Phone2'],
        Standard:this.studentData['Standard'],
        Comment:this.Comment,
        ReminderDate:this.date,
        FUserId:this.FUserId,
        CreatedByName:this.userName
      }
    }

    if(this.dataFromEnquiry)
    {
      this.send_data={
        FWebEnquiryId:this.FWebEnquiryId,
        FDataId:this.FDataId,
        FStatusId:this.FStatusId,
        Name:this.Name,
        SchoolId:this.SchoolId,
        Phone1:this.Phone1,
        Phone2:this.Phone2,
        Standard:this.Standard,
        Comment:this.Comment,
        ReminderDate:this.date,
        ReminderTime:this.time,
        FUserId:this.FUserId,
        CreatedByName:this.userName
      }
    }


    if(this.date == null || this.date == '' || this.date == undefined)
    {
      this.toast("Select Date");
    }
    else
    {
      this.service.httppostcall('app_web_service/add_call_reminder',this.send_data).subscribe(val=>{
        if(val['status']=='success')
        {
          if(this.changeStatus=='1')
          {
            this.service.httppostcall('app_web_service/add_callStatus_On_reminder?FCallReminderId='+this.FCallReminderId+'&FCallStatusId=' + this.FCallStatusId+'&FUserId='+this.FUserId+'&UpdatedByName='+this.userName,'').subscribe(data1 => {

                }
                ,(error2 => {

                }))
          }
          this.viewCtrl.dismiss();
          this.toast(val['message']);
        }
        else
        {
          this.toast(val['message']);
        }
      });
    }




  }


  toast(msg)
  {
    let toast=this.toastCtrl.create({
      message:msg,
      duration:1000
    });

    toast.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/add-call-reminder/add-call-reminder.ts